<template>
  <div id="trailer" class="row">
    <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 csp-text-center">
      <span class="csp-trailer-text">
        &copy; {{ copyrightYear }} <a class="csp-router-link-text" v-bind:href="website">{{ company }}</a><br>
        <a :href="phonelink">{{ companyPhoneNumber | phone }}</a>
        <ul v-if="socialIcons" class="social">
          <li v-for="(object, name) in socialLinks">
              <social-icon :object="object" :name="name"></social-icon>
          </li>
       </ul>
     </span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SocialIcon from './SocialIcon'

export default {
  name: 'trailer',
  components: {
    SocialIcon
  },
  props: {
    socialIcons: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    phonelink: function () {
      return 'tel:+1' + this.companyPhoneNumber
    },
    ...mapGetters([
      'company',
      'companyPhoneNumber',
      'copyrightYear',
      'socialLinks',
      'website'
    ])
  }
}
</script>

<style>
  .social li { 
    width: 21px; 
    height:19px; 
    margin: 5px 10px 10px; 
    display: inline-block;
  }
  .social a { 
    width:21px; 
    height:19px; 
    position:absolute; 
    display: block;
    cursor: pointer;
    margin-top:5px;
    font-size: initial;
  }
  
  .csp-trailer-text{
    color: white;
    font-size: .86em;
    text-shadow: 0px 0px 4px #000;
    padding:0px;
  }
  
  .csp-trailer-text a{
    color: white;
    text-shadow: 0px 0px 4px #000;
    padding:0px;
  }
  
  .csp-trailer-text a:hover{
    color: white;
    border-bottom-color: #6B8F53;
  }
  
  .csp-router-link-text {
    color: white;
    border-bottom: solid white medium;
    cursor: pointer;
    text-shadow: 0px 0px 4px #000;
    white-space: nowrap;
  }
  
  .csp-router-link-text:hover{
    color: white;
    border-bottom-color: #6B8F53;
  }
  
  @media only screen and (max-width: 767px) {
    
  }
</style>



// WEBPACK FOOTER //
// Trailer.vue?1cafe850